import { createContext } from 'react';

export type UpdateType = 'dialogue' | 'activities';

type UnreadState = {
  dialogue: Map<number, number>; // customerId → timestamp
  activities: Map<number, number>; // customerId → timestamp
};

type UnifiedDialogContextType = {
  unread: UnreadState;
  dialogueIncrements: Map<number, number>;
  totalUnreadCount: number;
  addUnread: (customerId: number, type: UpdateType) => void;
  markRead: (customerId: number) => void;
  hasUnread: (customerId: number) => boolean;
  sortWithUnreadFirst: <T extends {id: number}>(items: T[]) => T[];
  getIncrementalCount: (customerId: number) => number;
  resetIncrementalCount: (customerId: number) => void;
  setTotalUnreadCount: (count: number) => void;
};

const defaultValue: UnifiedDialogContextType = {
  unread: {
    dialogue: new Map(),
    activities: new Map(),
  },
  dialogueIncrements: new Map(),
  totalUnreadCount: 0,
  addUnread: () => {
    // Default noop
  },
  markRead: () => {
    // Default noop
  },
  hasUnread: () => false,
  sortWithUnreadFirst: <T extends {id: number}>(items: T[]) => items,
  getIncrementalCount: () => 0,
  resetIncrementalCount: () => {
    // Default noop
  },
  setTotalUnreadCount: () => {
    // Default noop
  },
};

export const UnifiedDialogContext = createContext<UnifiedDialogContextType>(defaultValue);

export type { UnifiedDialogContextType, UnreadState };
